import PropTypes from "prop-types";
import Text from "components/Common/Text";

export const matchPlayColorScheme = (value) => {
  if (value > 0) {
    return {
      color: "#01AE27",
      backgroundColor: "#E6FDEB",
      fontColor: "#FFFFFF",
      valueFontColor: "#01AE27",
      activeColorTeam: "#379FDC",
      notActiveColorTeam: "#EDEFEF",
    };
  }
  if (value < 0) {
    return {
      color: "#E24955",
      backgroundColor: "#FCEDEE",
      fontColor: "#FFFFFF",
      valueFontColor: "#E24955",
    };
  }
  if (value === 0) {
    return {
      color: "#EDEFEF",
      backgroundColor: "#FFFFFF",
      fontColor: "#8E9191",
      valueFontColor: "#8E9191",
    };
  }
  return {
    color: null,
    backgroundColor: null,
  };
};

export const formatValue = ({ payouts, value }) => {
  if (+value === 0) {
    if (payouts) {
      return 0;
    }
    return "AS";
  }
  if (+value < 0) {
    return value;
  }
  if (+value > 0) {
    return `+${value}`;
  }

  return "ERR";
};

export function MatchPlayCard({ type, score }) {
  return (
    <div
      style={{
        height: 80,
        minWidth: 84,
        backgroundColor: matchPlayColorScheme(score).backgroundColor,
        borderWidth: 2,
        borderStyle: "solid",
        borderColor: matchPlayColorScheme(score).color,
        borderRadius: 10,
        overflow: "hidden",
        marginRight: 6,
      }}
    >
      <div
        style={{
          backgroundColor: matchPlayColorScheme(score).color,
          padding: "5px",
        }}
      >
        <Text
          as="C1"
          bold
          ta="center"
          style={{ color: matchPlayColorScheme(score).fontColor }}
        >
          {type}
        </Text>
      </div>
      <Text
        ta="center"
        as="H1"
        style={{
          color: matchPlayColorScheme(score).valueFontColor,
          alignItems: "center",
          padding: 7,
        }}
      >
        {formatValue({ value: score })}
      </Text>
    </div>
  );
}
MatchPlayCard.propTypes = {
  score: PropTypes.number.isRequired,
  type: PropTypes.string.isRequired,
};
